import { render, staticRenderFns } from "./GlobalContactButton.vue?vue&type=template&id=1616c6bf&"
import script from "./GlobalContactButton.vue?vue&type=script&lang=ts&"
export * from "./GlobalContactButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import { VBtn } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {GFaIcon,VBtn,VToolbarItems})
